import { FilterInterface } from "../../../interfaces/entities/FilterInterface";
import { OrderingAtestadosEnum } from "../../../interfaces/enum/OrderingAtestadosEnum";

export const orderingOptionsDefault: FilterInterface[] = [
  {
    id: OrderingAtestadosEnum.MaisAntigo,
    descricao: OrderingAtestadosEnum.MaisAntigo
  },
  {
    id: OrderingAtestadosEnum.MaisRecente,
    descricao: OrderingAtestadosEnum.MaisRecente
  },
]